import { baseApi } from './baseApi';

function inferRead(row) {
  if (row == null || typeof row !== 'object') return false;
  if (Object.prototype.hasOwnProperty.call(row, 'read')) return !!row.read;
  if (Object.prototype.hasOwnProperty.call(row, 'is_read')) return !!row.is_read;
  if (row.read_at != null && String(row.read_at).trim() !== '') return true;
  if (Object.prototype.hasOwnProperty.call(row, 'seen')) return !!row.seen;
  return false;
}

function trimOrEmpty(v) {
  if (v == null) return '';
  const s = String(v).trim();
  return s;
}

function normalizeEmailHistoryList(response) {
  const raw =
    response?.data ??
    response?.email_histories ??
    response?.email_history ??
    (Array.isArray(response) ? response : null);
  const list = Array.isArray(raw) ? raw : [];
  const data = list.map((row) => {
    const id = row.id ?? row.email_history_id;
    const read = inferRead(row);
    const notifySubject = trimOrEmpty(row.subject);
    const notifyContent = trimOrEmpty(row.description ?? row.content);
    const createdAt =
      row.created_at ?? row.sent_at ?? row.updated_at ?? row.createdAt ?? null;
    return { ...row, id, read, notifySubject, notifyContent, createdAt };
  });
  return { ...response, data };
}

export const emailHistoryApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getEmailHistories: builder.query({
      query: () => '/api/email_histories',
      providesTags: ['EmailHistories'],
      transformResponse: normalizeEmailHistoryList,
    }),
    markEmailHistoryAsRead: builder.mutation({
      query: (id) => ({
        url: `/api/email_histories/${encodeURIComponent(String(id))}/mark_as_read`,
        method: 'PATCH',
      }),
      invalidatesTags: ['EmailHistories'],
    }),
    markAllEmailHistoriesRead: builder.mutation({
      query: () => ({
        url: '/api/email_histories/mark_read_all',
        method: 'PATCH',
      }),
      invalidatesTags: ['EmailHistories'],
    }),
  }),
});

export const {
  useGetEmailHistoriesQuery,
  useMarkEmailHistoryAsReadMutation,
  useMarkAllEmailHistoriesReadMutation,
} = emailHistoryApi;
